import styled from "styled-components";
import { Colors as LightColors,DarkColors } from "../../style/colors";
import { Success,Exclamation } from "../../constants/images";
import { Field,FieldConfig } from "../fields";
import { useDictionary } from "../../contexts/dictionary";




interface FormProps {
  fields: FieldConfig[];
  serverRes?: ApiResponse | null
  onChange:(name:string,value:any,valid:boolean)=>void;
  title?: string;
  align?:'flex-start'| 'flex-end'| 'center'
  subTitle?:any;
  showMessageBox?:boolean;
  theme?:'light'|'dark';
}




export const FormComponent = ({ fields, title, subTitle,onChange,serverRes,showMessageBox=true,align='center',theme='light' }: FormProps) => {
  const Colors = theme==='light'?LightColors:DarkColors
  const { translate } = useDictionary();

  return (
    <FormContainer>
      
      {title && <Title $align={align} $Colors={Colors}>{title}</Title>}
      {serverRes && showMessageBox &&<MessageBox $align={align} $Colors={Colors}><Icon src={serverRes.succeeded?Success : Exclamation}/><Text id="text">{translate(serverRes.message)}</Text></MessageBox>}
      
      {subTitle}
      {
      fields.map((field, index) => {
        return (
        <Field
          key={index}
          fieldConfig={field}
          onChange={onChange}
          serverRes={serverRes}
          theme={theme}
        />
        )
        
      })
      }
      
    </FormContainer>
  );
};

const FormContainer = styled.div`
display:flex;
flex-direction:column;
align-items: center; /* This will center the items horizontally */
justify-content: center; /* This will center the items vertically and space them evenly */
background-color: transparent;
width: 100%;
margin-bottom: 10px;
`
const Title=styled.h3<{$align:'flex-start'| 'flex-end'| 'center' ,$Colors:any}>`
color: ${props=>props.$Colors.blackText};
margin: 0;
margin-bottom: 10px;
align-self:${prop=>prop.$align};
`

const MessageBox = styled.div<{$align:'flex-start'| 'flex-end'| 'center',$Colors:any }>`
display:flex;
align-items: center;
justify-content: flex-start; /* This will center the items vertically and space them evenly */
background-color: ${props=>props.$Colors.messageBox};
padding: 10px;
align-self:${prop=>prop.$align};
width: 80%;
margin-bottom: 10px;
margin-top: 0px;
border-radius: 8px;
`

const Text = styled.div`
  display:flex;
  width: 100%;
justify-content: center;
`


const Icon = styled.img`
  width: 16px;
  height: 16px;
`;
